import type { Dispatch, SetStateAction } from 'react'

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

import type {
  OptionRequestDialogState,
  OptionRequestFormState,
} from '../types/dropdown.types'

type DropdownOptionRequestDialogProps = {
  requestDialog: OptionRequestDialogState
  requestForm: OptionRequestFormState
  onClose: () => void
  onSubmit: () => void
  setRequestForm: Dispatch<SetStateAction<OptionRequestFormState>>
}

export function DropdownOptionRequestDialog({
  requestDialog,
  requestForm,
  onClose,
  onSubmit,
  setRequestForm,
}: DropdownOptionRequestDialogProps) {
  return (
    <Dialog open={requestDialog.open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Request New {requestDialog.label} Option</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Requested Value"
            fullWidth
            required
            value={requestForm.requested_label}
            onChange={event => setRequestForm(form => ({ ...form, requested_label: event.target.value }))}
            placeholder={`Enter the ${requestDialog.label.toLowerCase()} value you need`}
          />
          <TextField
            label="Why is this needed?"
            fullWidth
            multiline
            rows={3}
            value={requestForm.justification}
            onChange={event => setRequestForm(form => ({ ...form, justification: event.target.value }))}
            placeholder="Optional context for the admin reviewer"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          Submit Request
        </Button>
      </DialogActions>
    </Dialog>
  )
}
